module.exports = __webpack_public_path__ + "img/play.3de91a05.svg";